module.exports = __webpack_public_path__ + "img/hero-bg2.1e92d0ac.jpg";